import icon_logo from "./icon_logo.png";
import logo_horizantal from "./logo_horizantal.png";

export const Images = {
  icon_logo,
  logo_horizantal,
};
